export const isAdmin = () =>  window && window.location.pathname.match('/admin');